const routes = [
    {
        path: "/holiday",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "holiday_index"
        }
    }
]

export default routes;
